import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useMemo } from 'react';
import { RumComponentContext } from './rum-component-context';
/**
 * Context Provider to add a new component to the action breadcrumbs. Useful for class Components.
 */
export var RumComponentContextProvider = function (_a) {
    var componentName = _a.componentName, customAttributes = _a.customAttributes, children = _a.children;
    var parentContext = useContext(RumComponentContext);
    var newContext = useMemo(function () { return ({
        component: componentName,
        customAttributes: __assign(__assign({}, parentContext.customAttributes), customAttributes),
        componentBreadCrumbs: parentContext.componentBreadCrumbs + "." + componentName
    }); }, [
        componentName,
        parentContext.componentBreadCrumbs,
        parentContext.customAttributes,
        customAttributes
    ]);
    return (_jsx(RumComponentContext.Provider, __assign({ value: newContext }, { children: children }), void 0));
};
export function WithRumComponentContext(componentName, options, Component) {
    if (typeof Component === 'undefined') {
        return WithRumComponentContext(componentName, {}, options);
    }
    return function (props) {
        return (_jsx(RumComponentContextProvider, __assign({ componentName: componentName, customAttributes: options.customAttributes }, { children: _jsx(Component, __assign({}, props), void 0) }), void 0));
    };
}
//# sourceMappingURL=RumComponentContext.js.map